"use strict";
import React, { useRef } from "react";
import Button, { ButtonSize } from "../Button/Button";
import TextInput, { TextInputSize } from "../TextInput/TextInput";
import CopyToClipboard from "../../behaviors/CopyToClipboard/CopyToClipboard";
import { randomString } from "../../../utils";
const CopyInput = ({
  value,
  onCopy: onCopyCallback,
  label,
  labelHidden,
  size = TextInputSize.Medium,
  buttonContent = "Copy"
}) => {
  const copyInputRef = useRef(null);
  const copyInputId = useRef(`copy-input-${randomString()}`);
  const handleCopy = (onCopy) => {
    onCopyCallback == null ? void 0 : onCopyCallback();
    onCopy();
  };
  const handleInputFocus = () => {
    var _a;
    (_a = copyInputRef.current) == null ? void 0 : _a.select();
  };
  return /* @__PURE__ */ React.createElement(
    TextInput,
    {
      readOnly: true,
      className: "kl-copy-input",
      id: copyInputId.current,
      ref: copyInputRef,
      onFocus: handleInputFocus,
      labelHidden,
      value,
      label,
      size,
      endElement: /* @__PURE__ */ React.createElement(CopyToClipboard, { showTooltipOnCopy: true, value }, ({ onCopy }) => /* @__PURE__ */ React.createElement(
        Button,
        {
          "aria-labelledby": `${copyInputId.current}-label`,
          size: getButtonSize(size),
          onClick: () => handleCopy(onCopy)
        },
        buttonContent
      ))
    }
  );
};
const getButtonSize = (inputSize) => {
  const sizeMap = /* @__PURE__ */ new Map([
    [TextInputSize.Small, ButtonSize.XSmall],
    [TextInputSize.Medium, ButtonSize.Small],
    [TextInputSize.Large, ButtonSize.Medium]
  ]);
  return sizeMap.get(inputSize) || ButtonSize.Small;
};
export default CopyInput;
